// WhatsApp a un tocco: nessuna API, nessun costo. Il portale prepara il
// link wa.me col messaggio precompilato e il ristoratore preme solo
// "invia" dal proprio WhatsApp — il messaggio arriva dal suo numero
// vero, e il cliente può rispondere.

/** Normalizza un numero (di solito italiano) nel formato wa.me: solo cifre, con prefisso internazionale. */
export function waNumber(phone: string): string {
  let d = phone.replace(/\D/g, '');
  if (d.startsWith('00')) d = d.slice(2);
  // Mobile italiano scritto senza prefisso (3xx xxx xxxx) → aggiungi 39.
  if (d.length === 10 && d.startsWith('3')) d = `39${d}`;
  return d;
}

export function waLink(phone: string, text: string): string {
  return `https://wa.me/${waNumber(phone)}?text=${encodeURIComponent(text)}`;
}

interface WaBookingInput {
  name: string;
  covers: number;
  /** HH:mm — sempre presente. */
  start: string;
  /** ISO completo — presente solo coi dati reali; senza, il messaggio omette il giorno. */
  startsAt?: string;
}

/** Il messaggio per il cliente è sempre in italiano: è rivolto ai clienti del ristorante. */
export function waBookingMessage(
  resv: WaBookingInput,
  tenantName: string,
  outcome: 'conf' | 'cancel',
): string {
  const firstName = resv.name.trim().split(/\s+/)[0] ?? resv.name;
  // timeZone UTC per convenzione di piattaforma: il form salva l'orario
  // "del muro" come se fosse UTC, e `start` (HH:mm) viene dallo stesso
  // orologio — senza il pin, il giorno seguirebbe il fuso del browser.
  const day = resv.startsAt
    ? new Date(resv.startsAt).toLocaleDateString('it-IT', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        timeZone: 'UTC',
      })
    : null;
  const when = day ? `${day} alle ${resv.start}` : `le ${resv.start}`;

  if (outcome === 'conf') {
    return `Buonasera ${firstName}, il tavolo per ${resv.covers} di ${when} da ${tenantName} è confermato. A presto!`;
  }
  return `Buonasera ${firstName}, purtroppo per ${when} non riusciamo ad accogliere la prenotazione. La richiamiamo volentieri per trovare un'alternativa. — ${tenantName}`;
}
